import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import BlobProfile from './BlobProfile';
import { GridImagesCaption } from './GridImagesCaption';
import MessageBlobCaption from './MessageBlobCaption';
import MessageIllustration from './MessageIllustration';
import MessageIllustratedList from './MessageIllustratedList';
import MessageImageCaption from './MessageImageCaption';
import { QuoteComponent } from './QuoteComponent';
import MessageAnimation from './MessageAnimation';
import HighlightCaption from './HighlightCaption';

const messageBlobCaption = ({
  imageUrl,
  imageHeight,
  centreMessageOnMobile,
  colorThemeOption,
  captionImage,
  captionImageHeight,
  blobBleed,
  blobBleedConfig,
  shouldShowDecorativeBlob,
  imageWidth,
  blobHeight,
  showBorder,
  isCard,
  shouldUseConfigOffsetFirefox
}) => {
  return {
    component: MessageBlobCaption,
    imageUrl,
    imageHeight,
    centreMessageOnMobile,
    colorThemeOption,
    captionImage,
    captionImageHeight,
    blobBleed,
    blobBleedConfig,
    shouldShowDecorativeBlob,
    imageWidth,
    blobHeight,
    showBorder,
    isCard,
    shouldUseConfigOffsetFirefox
  };
};

const blobProfile = ({
  imageUrl,
  colorThemeOption,
  blobBleed,
  imageHeight,
  blobBleedConfig
}) => ({
  component: BlobProfile,
  imageUrl,
  colorThemeOption,
  blobBleed,
  imageHeight,
  blobBleedConfig
});

const imageMessage = ({
  imageKey,
  altText
}) => ({
  component: MessageImageCaption,
  imageKey,
  altText
});

const illustration = ({
  illustrationName,
  height,
  imageHeights,
  colorThemeOption,
  topMargin
}) => Object.assign({
  component: MessageIllustration,
  illustrationName,
  height,
  imageHeights,
  topMargin
}, colorThemeOption && {
  colorThemeOption
});

const illustratedList = ({
  illustrationName,
  height,
  isHTMLMessage,
  imageHeights,
  colorThemeOption,
  animationDelay,
  // TODO Remove after running GOSU-0001
  footerComponent
}) => Object.assign({
  component: MessageIllustratedList,
  illustrationName,
  height,
  isHTMLMessage,
  imageHeights
}, colorThemeOption && {
  colorThemeOption
}, {
  animationDelay,
  footerComponent
});

const animation = ({
  imageUrl,
  renderBlob,
  colorThemeOption,
  shouldShowDecorativeBlob,
  blobBleed,
  imageHeight,
  imageWidth,
  blobBleedConfig,
  loop,
  isCard,
  blobHeight,
  topMargin
}) => ({
  component: MessageAnimation,
  imageUrl,
  renderBlob,
  colorThemeOption,
  shouldShowDecorativeBlob,
  blobBleed,
  imageHeight,
  imageWidth,
  blobBleedConfig,
  loop,
  blobHeight,
  isCard,
  topMargin
});

const quote = ({
  imageUrl,
  imageHeights,
  altText
} = {}) => ({
  component: QuoteComponent,
  imageUrl,
  imageHeights,
  altText
});

const imagesInGrid = ({
  imageArray,
  bgColor
}) => ({
  component: GridImagesCaption,
  imageArray,
  bgColor
});

const highlightCaption = ({
  dataKey,
  highlightMessageKeys,
  landingPageComponent,
  illustrationName,
  height
}) => {
  return {
    component: HighlightCaption,
    landingPageComponent,
    dataKey,
    highlightMessageKeys,
    // Illustration passthrough props
    illustrationName,
    height
  };
};

const BusinessBoxCarouselWrapper = /*#__PURE__*/lazy(() => import('./BusinessBoxCarouselWrapper'));

const businessBox = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(BusinessBoxCarouselWrapper, {})
  })
});

export const MessageTypes = {
  imagesInGrid,
  quote,
  illustration,
  illustratedList,
  imageMessage,
  blobProfile,
  messageBlobCaption,
  animation,
  highlightCaption,
  businessBox
};